<template>
  <div
    class="relative items-start gap-6 bg-anthracite-500 py-13 text-white md:px-0 md:py-8"
  >
    <div
      :class="{ 'md:grid-cols-[minmax(300px,1fr)_2fr]': !showResponseOverlay }"
      class="container grid grid-cols-1 gap-6"
    >
      <template v-if="!showResponseOverlay">
        <div class="flex space-x-6">
          <div>
            <IconSnipesNewsletter class="size-9 fill-white md:size-14" />
          </div>
          <div class="flex flex-col space-y-2">
            <div
              class="font-sans text-[24px] font-medium leading-7 md:text-[28px] md:leading-8"
            >
              {{ $t('newsletter.header_title') }}
            </div>
          </div>
        </div>
        <div class="flex w-full flex-col justify-end space-y-4">
          <SFNewsletterForm
            class="w-full justify-end"
            @on-response="handleResponse"
          />
          <div class="flex justify-end">
            <div
              class="max-w-[840px] text-[16px] font-normal leading-[22px] md:text-[14px] md:leading-[18px]"
            >
              <I18nT keypath="newsletter.opt_in" tag="p">
                <template #privacy>
                  <SFLink
                    :to="getLocalizedRoute('/s/privacypolicy')"
                    class="underline"
                    raw
                  >
                    {{ $t('global.privacy') }}
                  </SFLink>
                </template>
              </I18nT>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div
          class="relative z-10 flex w-full flex-col items-center justify-center bg-anthracite-500 p-8"
        >
          <SFButton variant="raw" @click="showResponseOverlay = false">
            <IconSnipesClosecircleoutlined
              class="absolute -top-4 right-[30px] z-10 size-[30px] text-white"
            />
          </SFButton>
          <IconSnipesNewsletter class="mb-6 size-[40px]" />
          <div
            class="py-4 text-[16px] font-bold leading-5 md:text-[18px] md:leading-[22px]"
          >
            {{ $t(`newsletter.${overlayMessagesPrefix}.headline`) }}
          </div>
          <div class="text-center text-[14px] leading-[18px]">
            {{ $t(`newsletter.${overlayMessagesPrefix}.subline`) }}
          </div>
          <div class="text-center text-[14px] leading-[18px]">
            {{ $t(`newsletter.${overlayMessagesPrefix}.confirm_text`) }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import SFNewsletterForm from '~/components/footer/SFNewsletterForm.vue'
import { SFButton, SFLink } from '#storefront-ui/components'
import { useRouteHelpers, useTrackingEvents } from '~/composables'
import { NewsletterAction } from '~/composables/tracking/events/useNewsletterEvents'
import { I18nT } from '#i18n'

const { getLocalizedRoute } = useRouteHelpers()

const { trackNewsletter } = useTrackingEvents()
const showResponseOverlay = ref(false)
const overlayMessagesPrefix = ref('success')

const handleResponse = async (
  status: string,
  data?: { email: string; referenceKey: string },
) => {
  await trackNewsletter({
    action: NewsletterAction.Footer,
    email: data?.email,
    referenceKey: data?.referenceKey,
  })
  overlayMessagesPrefix.value = status
  showResponseOverlay.value = true
}
</script>
